import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applyDiscount, clearDiscount } from "../../../redux/promoSlice";
import { toast } from "react-toastify";
import api from "../../../utils/api";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Swal from "sweetalert2";
import Cookies from 'js-cookie'
import { FaPoundSign } from "react-icons/fa";
import { showCustomAlert } from "../Signup/Toast";
export default function OrderSummary1() {
  const [points, setPoints] = useState(0); // Initialize points state
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate(); // Using react-router's navigate for programmatic routing

  // Fetch points from the backend API
  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const response = await api.get(`/current-points/user/${user._id}`);
        setPoints(response.data.data.currentPoint);
        console.log("🚀 ~ fetchPoints ~ response:", response);
      } catch (error) {
        console.error("error fetching points:", error);
      }
    };
    fetchPoints();
  }, [user]);

  const [promoCode, setPromoCode] = useState("");
  const [error, seterror] = useState(null);
  const { cart } = useSelector((state) => state.cart);
  const { discount } = useSelector((state) => state.promo);
  const dispatch = useDispatch();

  if (cart.length === 0) {
    return (
      <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10">
        <h2 className="text-2xl font-bold text-black text-center">
          Your cart is empty.
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Please add some items to your cart to view the order summary.
        </p>
      </section>
    );
  }

  if (!cart || cart.length === 0) return null;

  const selectedProductIds = cart.map((item) => item._id);
  const handlePromoCodeSubmit = async () => {
    if (!promoCode.trim()) {
      seterror("Please enter a promo code.");
      showCustomAlert({
        title: 'Promo code not found.',
                     html: '<p style="color: #555;"> Please check the code and try again</p>',
        icon: 'error',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 3000
      })
      return;
    }

    dispatch(clearDiscount());
    try {
      const response = await api.get(`/promo-code/by-code/${promoCode}`);
      const { data } = response;

      console.log("API Response Data:", data);

      if (data && data.status === 1) {
        const promoData = data.data;

        // Ensure selectedProductIds is an array
        const selectedProducts = Array.isArray(selectedProductIds)
          ? selectedProductIds
          : [];
        console.log(
          "🚀 ~ handlePromoCodeSubmit ~ selectedProducts:",
          selectedProducts
        );

        // Ensure promoData.productId is an array
        const promoProductIds = Array.isArray(promoData.productId)
          ? promoData.productId
          : [];
        console.log(
          "🚀 ~ handlePromoCodeSubmit ~ promoProductIds:",
          promoProductIds
        );

        // Check if any selected product matches the promo product ID
        const isValidProduct = promoProductIds.some(
          (productId) =>
            selectedProducts && selectedProducts.includes(String(productId))
        );

        console.log(
          "🚀 ~ handlePromoCodeSubmit ~ isValidProduct:",
          isValidProduct
        );

        if (isValidProduct) {
          // Applying the discount
          dispatch(
            applyDiscount({
              promoCode: promoData,
            })
          );

          seterror(null);
          showCustomAlert({
            title: 'Promo code applied !',
                         html: '<p style="color: #555;"> Promo code applied successfully!</p>',
            icon: 'success',
            confirmButtonText: 'ok',
            confirmButtonColor: '#af313d',
            background: '#ffffff',
            timer: 3000
          })
        
        } else {
          seterror(
            "This promo code is not applicable to the selected products."
          );
         showCustomAlert({
                   title: 'Promo code not found.',
                                html: '<p style="color: #555;"> Please check the code and try again</p>',
                   icon: 'error',
                   confirmButtonText: 'ok',
                   confirmButtonColor: '#af313d',
                   background: '#ffffff',
                   timer: 3000
                 })
        }
      } else {
        seterror("Invalid promo code.");
       showCustomAlert({
                 title: 'Promo code not found.',
                              html: '<p style="color: #555;"> Please check the code and try again</p>',
                 icon: 'error',
                 confirmButtonText: 'ok',
                 confirmButtonColor: '#af313d',
                 background: '#ffffff',
                 timer: 3000
               })
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        seterror("Promo code not found. Please check the code and try again.");
        showCustomAlert({
                  title: 'Promo code not found.',
                               html: '<p style="color: #555;"> Please check the code and try again</p>',
                  icon: 'error',
                  confirmButtonText: 'ok',
                  confirmButtonColor: '#af313d',
                  background: '#ffffff',
                  timer: 3000
                })
       
      } else {
        seterror("An error occurred while validating the promo code.");
       showCustomAlert({
                 title: 'Promo code not found.',
                              html: '<p style="color: #555;"> Please check the code and try again</p>',
                 icon: 'error',
                 confirmButtonText: 'ok',
                 confirmButtonColor: '#af313d',
                 background: '#ffffff',
                 timer: 3000
               })
      }
      console.error("Promo Code error:", err);
    }
  };

  // Adjust the subtotal calculation
  const subtotal = cart.reduce(
    (total, item) => total + item.basePrice * item.quantity,
    0
  );

  // Apply discount only on applicable products
  const discountAmount = cart.reduce((discountTotal, item) => {
    console.log(
      "🚀 ~ discountAmount ~ discount:",
      discount?.promoCode?.productId
    );

    const isDiscountApplicable =
      discount &&
      Array.isArray(discount?.promoCode?.productId) &&
      discount?.promoCode?.productId.includes(item._id);
    console.log(
      "🚀 ~ discountAmount ~ isDiscountApplicable:",
      isDiscountApplicable
    );

    if (isDiscountApplicable) {
      discountTotal +=
        (item.basePrice * item.quantity * discount?.promoCode?.discount) / 100; // Apply discount only on the applicable item
    }
    return discountTotal;
  }, 0);

  const total = subtotal - discountAmount;

  console.log("Subtotal:", subtotal);
  console.log("Discount Amount:", discountAmount);
  console.log("Total:", total);

  // Logic to check if the points are enough for checkout
  const isCheckoutAvailable = points >= total;



const handleCheckout = () => {
  if (isCheckoutAvailable) {
    // Show Swal popup with checkbox options
    Swal.fire({
      title: 'Your points are sufficient. Choose your payment method:',
    
      confirmButtonColor: '#af313d',
        background: '#ffffff',
     
      input: 'radio',
      inputOptions: {
        points: 'Pay from cashback',
        card: 'Pay with credit card',
      },
      inputValidator: (value) => {
        if (!value) {
          return 'You need to select a payment method!';
        }
      },
      confirmButtonText: 'Proceed',
      showCancelButton: false,
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        // Navigate based on the selected option
      
        if (result.value === 'points') {
          // const storePoints = Cookies.set('pointsSufficient', true)
          navigate('/delivery', { state: { pointsSufficient: true } });
        } else if (result.value === 'card') {
          // const storePoints = Cookies.set('pointsSufficient', false)
          navigate('/delivery', { state: { pointsSufficient: false } });
        }
      }
    });
  } else {
    // Navigate to delivery if points are insufficient
    navigate('/delivery', { state: { pointsSufficient: false } });
  }
};

  return (
    <>
      <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10 ">
        <div className="flex items-center flex-wrap gap-5 justify-between max-md:max-w-full">
          <div className="flex flex-col items-start self-start text-2xl font-medium leading-none text-black">
            <h2 className="self-stretch lg:text-[40px] md:text-[27.97px] font-baloo sm:text-[14px] text-[14px] font-bold leading-tight">
              Order Summary
            </h2>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <div className="flex flex-col leading-[64px]">
            {cart.map((item, index) => (
              <div
                key={index}
                className="rotate-[3.469446951953614e-18rad] font-baloo font-medium text-[#000000] text-[11.75px] sm:text-[11.75px] md:text-[17.48px] lg:text-[25px]"
              >
                {item.name} x {item.quantity}
              </div>
            ))}
          </div>
          <div className="flex flex-col self-end font-semibold whitespace-nowrap leading-[64px] text-slate-800 ">
            {cart.map((item, index) => (
              <div
                key={index}
                className="rotate-[9.19348695318866e-19rad] text-[11.56px] sm:text-[10.56px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]"
              >
                £{(item.basePrice * item.quantity).toFixed(2)}
              </div>
            ))}
          </div>
        </div>

        <hr className="shrink-0 mt-1.5  w-full border-rose-700 border-solid border-[3px]" />

        <div className="mt-4 flex flex-col">
          <div className="flex justify-between items-center text-center">
            <div className="font-baloo font-bold lg:text-[22px] text-[11.4px] sm:text-[11.4px] md:text-[16.78px]">
              Subtotal
            </div>
            <div className="lg:text-[34px] font-bold text-[12px] sm:text-[12px] md:text-[20.98px] flex justify-center items-center">
              {" "}
              <FaPoundSign className="mr-1" /> {subtotal.toFixed(2)}
            </div>
          </div>

          {discount && (
            <div className="flex justify-between mt-4">
              <div className="text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[11.5px] sm:text-[11.5px] md:text-[20.98px] ">
                Discount
              </div>
              <div className="text-[#C97C2A] font-baloo font-bold lg:text-[40px] md:text-[27.97px] flex items-center justify-center">
                {" "}
                <FaPoundSign className="mr-1" /> -{discountAmount.toFixed(2)}
              </div>
            </div>
          )}

          <div className="flex justify-between mt-4">
            <div className="text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[12.5px] sm:text-[12.5px] md:text-[20.98px] ">
              Total
            </div>
            <div className="text-[#C97C2A] font-baloo font-bold lg:text-[40px] md:text-[27.97px] text-[12px] flex items-center justify-center">
              {" "}
              <FaPoundSign className="mr-1" /> {total.toFixed(2)}
            </div>
          </div>
        </div>
      </section>
      <section className="flex md:flex-row flex-col flex-wrap gap-5 justify-between mx-auto items-center mt-10 w-[90%] mb-3">
        <div className="flex justify-between border-2 border-rose-700 px-2 rounded-full items-center h-12">
          <input
            type="text"
            placeholder="Apply promo code here"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            className="flex px-2 py-4 bg-transparent focus:outline-none text-base font-baloo"
          />
          <span
            className="bg-rose-700 text-white flex items-center p-1 px-3 justify-center gap-1 rounded-2xl body"
            onClick={handlePromoCodeSubmit}
          >
           Apply
          </span>
        </div>

        {/* {error && <p className="text-red-500">{error}</p>} */}
        <div className="flex items-center justify-center gap-2">
          <h1 className="body text-[22px] text-[#AF313D]  p-2 rounded-md px-5">Cashback points</h1>
          <p className="md:text-lg text-[14px] text-[#C97C2A] flex items-center">
            <FaPoundSign className="mr-1" /> {points} {/* Added euro icon */}
          </p>
        </div>
        <button
          onClick={handleCheckout}
          className="body text-[22px] bg-[#AF313D] text-white py-2 md:py-5 rounded-md px-16 "
        >
          Checkout
        </button>
      </section>
    </>
  );
}
